import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  getUserProfile,
  addNewRole,
  updateRole,
  deleteRoles,
  fetchRolesEntity,
} from "./thunk";

interface Roles {
  id: any;
  name: any;
  description: any;
  entity_id: any;
  enabled: any;
  permissions: any;
}

interface rolesState {
  roles: Roles[];
  error: string | null | {};
  loading: boolean;
  status: string;
}

export const initialState: rolesState = {
  roles: [],
  error: {},
  loading: false,
  status: "idle",
};

const RolesSlice = createSlice({
  name: "ContactsSlice",
  initialState,
  reducers: {
    listRoles(state) {
      state.loading = true;
      state.error = {};
    },
    fetchRolesSuccess(state, action) {
      state.loading = false;
      state.roles = action.payload;
    },
    fetchRolesFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    // ---------------------
    builder.addCase(fetchRolesEntity.pending, (state: any, action: any) => {
      state.status = "loading";
      state.loading = true;
    });
    builder.addCase(fetchRolesEntity.fulfilled, (state: any, action: any) => {
      state.status = "succeeded";
      state.loading = false;
      state.roles = action.payload; // Guardamos la lista de usuarios
    });
    builder.addCase(fetchRolesEntity.rejected, (state: any, action: any) => {
      state.status = "failed";
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(addNewRole.fulfilled, (state: any, action: any) => {
      state.loading = true;
    });
    builder.addCase(addNewRole.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(updateRole.fulfilled, (state: any, action: any) => {
      state.roles = state.roles.map((user: any) =>
        user.id === action.payload.id ? { ...user, ...action.payload } : user
      );
    });
    builder.addCase(updateRole.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });

    builder.addCase(deleteRoles.fulfilled, (state: any, action: any) => {
      console.log("deleteRoles", action.payload);
      state.roles = state.roles.filter(
        (roles: any) => roles.id !== action.payload.id
      );
    });
    builder.addCase(deleteRoles.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    // --------------------------------------------------------------
    builder.addCase(getUserProfile.fulfilled, (state: any, action: any) => {
      state.roles = action.payload;
    });

    builder.addCase(getUserProfile.rejected, (state: any, action: any) => {
      state.error = action.payload ? action.payload?.error : null;
    });
  },
});

export const { listRoles, fetchRolesSuccess, fetchRolesFailure } =
  RolesSlice.actions;

export default RolesSlice.reducer;
